import React from 'react';
import ActionItem from './ActionItem';
import { CheckCircle, Zap } from 'lucide-react';

const ActionCenter = ({ items = [], onNavigate }) => {
  const sorted = [...items].sort((a, b) => a.priority - b.priority);
  const hasUrgent = sorted.some(i => i.type === 'overdue_payments');

  return (
    <div className="mb-8">
      <div className="flex items-center gap-2.5 mb-3">
        <Zap className={`w-4 h-4 ${hasUrgent ? 'text-red-500' : 'text-slate-500'}`} />
        <h2 className="text-slate-800 text-base font-bold">Needs Attention</h2>
        {sorted.length > 0 && (
          <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
            hasUrgent ? 'bg-red-100 text-red-700' : 'bg-slate-100 text-slate-600'
          }`}>
            {sorted.length}
          </span>
        )}
      </div>
      {sorted.length === 0 ? (
        <div className="p-5 rounded-xl bg-emerald-50 border border-emerald-200 text-center">
          <CheckCircle className="w-7 h-7 text-emerald-500 mx-auto mb-1.5" />
          <p className="text-emerald-700 text-sm font-semibold">All caught up</p>
          <p className="text-emerald-500 text-xs mt-0.5">Nothing needs attention right now</p>
        </div>
      ) : (
        <div className="space-y-2">
          {sorted.map((item, i) => (
            <ActionItem key={`${item.type}-${item.memberId || i}`} item={item} onClick={onNavigate} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ActionCenter;
